import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Server-side redirect from the legacy `/clawinstall/admin/onboardings`
 * route to its renamed counterpart `/clawinstall/admin/installs`.
 *
 * Kept so external links and bookmarks (Linear, runbooks) continue to land
 * on the right page after the rename.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/admin/onboardings/")({
  beforeLoad: () => {
    throw redirect({ to: "/clawinstall/admin/installs" });
  },
});
